import act from './act';
export default {
  modelName: 'checklist_question_template',
  modelDraftName: 'cklist_question_template_draft',
  label: '點檢表公版題目',
  fields: {
    last_version: {
      type: 'last_version',
      fields: {
        is_in_stats: {
          type: 'checkbox',
          items: [
            {
              value: [1],
              text: '列入結果統計、不合規排行榜、今日點檢結論',
            },
          ],
          displayCheck(data) {
            return data.question_type && (
              data.question_type.value === 'single-choice' ||
              (data.question_type.value === 'num'&&
                data.numericalComparisonSetting &&
                data.numericalComparisonSetting.value !== 'num-only')
            );
          },
        },
        isInStats: {
          readonly: true,
          type: 'checkbox',
          label: '列入結果統計、不合規排行榜、今日點檢結論',
          items: [
            {
              value: [1],
              text: '是',
            },
            {
              value: [0],
              text: '否',
            },
          ],
        },
        question_type: {
          type: 'radio',
          label: '題目性質',
          rules: 'required',
          getUrl: 'question_type',
          getItems(rawDataList) {
            return rawDataList.map(rawData => {
              const {id, value, locales, name} = rawData;
              const _name = this.$_CMS_getTextFromLocales({locales, defaultVal:name});
              return {
                value: {id, value},
                text: _name,
              };
            });
          },
          getValue(rawData) {
            return rawData && rawData.id ? rawData.id : null;
          },
          setValue(rawData, rawDataList) {
            if (!rawData) return {text: '', value: null};
            const tarItem = rawDataList.find(item => item.value.id == rawData);
            return tarItem.value;
          }
        },
        option: {
          type: 'option',
          label: '選項快速設定',
          getRules(data) {
            return data.question_type && data.question_type.value === 'single-choice' ? 'required' : '';
          },
          displayCheck(data) {
            return data.question_type && data.question_type.value === 'single-choice';
          },
        },
        optionSetting: {
          readonly: true,
          type: 'text',
          label: '選項組合',
          displayCheck(data) {
            return data.last_version && data.last_version.question_type.value === 'single-choice';
          },
        },
        optionInfo: {
          readonly: true,
          type: 'option',
          label: '選項',
          displayCheck(data) {
            return data.last_version && data.last_version.question_type.value === 'single-choice';
          },
        },
        numericalComparisonSetting: {
          type: 'radio',
          label: '條件設定方式',
          getUrl: 'answer_setting',
          getItems(rawDataList) {
            return rawDataList.map(rawData => {
              const {id, type, locales, name} = rawData;
              const _name = this.$_CMS_getTextFromLocales({locales, defaultVal:name});
              return {
                value: {id, value: type},
                text: _name,
              };
            });
          },
          displayCheck(data) {
            return data.question_type && data.question_type.value === 'num';
          },
          getRules(data) {
            return data.question_type && data.question_type.value === 'num' ? 'required' : '';
          },
          getParams(data){
            return {question_type: data.question_type.id};
          },
          getValue(rawData) {
            if (!rawData) return null;
            return rawData.id;
          },
          setValue(rawData, rawDataList) {
            if (!rawData) return {text: '', value: null};
            const tarItem = rawDataList.find(item => item.value.id == rawData);
            return tarItem.value;
          }
        },
        numericalComparisonSettingInfo: {
          readonly: true,
          type: 'text',
          label: '條件設定方式',
          displayCheck(data) {
            return data.last_version && data.last_version.question_type.value === 'num';
          },
        },
        numericalComparisonConditionSetting:{
          type: 'numericalComparisonConditionSetting',
          label: '條件式設定',
          displayCheck(data) {
            return data.question_type &&
              data.question_type.value === 'num' &&
              data.numericalComparisonSetting &&
              data.numericalComparisonSetting.value === 'custom-num';
          },
          getRules(data) {
            return data.question_type &&
              data.question_type.value === 'num' &&
              data.numericalComparisonSetting &&
              data.numericalComparisonSetting.value === 'custom-num' ? 'required' : '';
          },
        },
        numericalComparisonConditionSettingInfo: {
          readonly: true,
          label: '條件式',
          type: 'numericalComparisonConditionSetting',
          displayCheck(data) {
            return data.last_version &&
              data.last_version.question_type.value === 'num' &&
              data.last_version.answer_setting.type === 'custom-num';
          },
        },
        control_limit_lower: {
          type: 'number',
          label: 'Control Limit (管制界限) 下限',
          getRules: function(fieldsValue) {
            return `min_value:${fieldsValue.spec_limit_lower}|max_value:${fieldsValue.control_limit_upper}`;
          },
          rulesErrorMessage: function(fieldsValue) {
            if (fieldsValue.spec_limit_lower >= this.value) {
              return '不可小於合規下限';
            }
            if (fieldsValue.control_limit_upper <= this.value) {
              return '不可大於管制上限';
            }
            return null;
          },
          displayCheck(data) {
            return (data.question_type &&
              data.question_type.value === 'num' &&
              data.numericalComparisonSetting &&
              data.numericalComparisonSetting.value === 'control-limit') ||
              (data.last_version &&
                data.last_version.question_type.value === 'num' &&
                data.last_version.answer_setting.type === 'control-limit');
          },
          sm: 6,
        },
        control_limit_upper: {
          type: 'number',
          label: 'Control Limit (管制界限) 上限',
          getRules: function(fieldsValue) {
            return `max_value:${fieldsValue.spec_limit_upper}|min_value:${fieldsValue.control_limit_lower}|min_value:${fieldsValue.spec_limit_lower}`;
          },
          rulesErrorMessage: function(fieldsValue) {
            if (fieldsValue.spec_limit_lower >= this.value) {
              return '不可小於合規下限';
            }
            if (fieldsValue.spec_limit_upper <= this.value) {
              return '不可大於合規上限';
            }
            if (fieldsValue.control_limit_lower >= this.value) {
              return '不可小於管制下限';
            }
            return null;
          },
          displayCheck(data) {
            return (data.question_type &&
              data.question_type.value === 'num' &&
              data.numericalComparisonSetting &&
              data.numericalComparisonSetting.value === 'control-limit') ||
              (data.last_version &&
                data.last_version.question_type.value === 'num' &&
                data.last_version.answer_setting.type === 'control-limit');
          },
          sm: 6,
        },
        spec_limit_lower: {
          type: 'number',
          label: 'Spec Limit (合規界限) 下限',
          getRules: function(fieldsValue) {
            return `max_value:${fieldsValue.control_limit_lower}|max_value:${fieldsValue.control_limit_upper}|max_value:${fieldsValue.spec_limit_upper}`;
          },
          rulesErrorMessage: function(fieldsValue) {
            if (fieldsValue.control_limit_lower <= this.value) {
              return '不可大於管制下限';
            }
            if (fieldsValue.control_limit_upper <= this.value) {
              return '不可大於管制上限';
            }
            if (fieldsValue.spec_limit_upper < this.value) {
              return '不可大於合規上限';
            }
            return null;
          },
          displayCheck(data) {
            return (data.question_type &&
              data.question_type.value === 'num' &&
              data.numericalComparisonSetting &&
              data.numericalComparisonSetting.value === 'control-limit') ||
              (data.last_version &&
                data.last_version.question_type.value === 'num' &&
                data.last_version.answer_setting.type === 'control-limit');
          },
          sm: 6,
        },
        spec_limit_upper: {
          type: 'number',
          label: 'Spec Limit (合規界限) 上限',
          getRules: function(fieldsValue) {
            return `min_value:${fieldsValue.control_limit_lower}|min_value:${fieldsValue.control_limit_upper}|min_value:${fieldsValue.spec_limit_lower}`;
          },
          rulesErrorMessage: function(fieldsValue) {
            if (fieldsValue.control_limit_lower <= this.value) {
              return '不可大於管制下限';
            }
            if (fieldsValue.control_limit_upper >= this.value) {
              return '不可小於管制上限';
            }
            if (fieldsValue.spec_limit_lower >= this.value) {
              return '不可小於合規下限';
            }
            return null;
          },
          displayCheck(data) {
            return (data.question_type &&
              data.question_type.value === 'num' &&
              data.numericalComparisonSetting &&
              data.numericalComparisonSetting.value === 'control-limit') ||
              (data.last_version &&
                data.last_version.question_type.value === 'num' &&
                data.last_version.answer_setting.type === 'control-limit');
          },
          sm: 6,
        },
        unit: {
          type: 'text',
          label: '單位',
          placeholder: '例如：cm、kg、kPa',
          displayCheck(data) {
            return (data.question_type && data.question_type.value === 'num') ||
              (data.last_version &&
                data.last_version.question_type.value === 'num');
          },
          sm: 6,
        },
        locales: {
          type: 'locales',
          // label: "多語言內容",
          displayLabel: false,
          fields: {
            control_limit_suggest: {
              type: 'text',
              label: 'Control Limit (管制界線) 設定建議',
              maxlength: 1000,
              displayCheck: function(fieldsValue) {
                if (!fieldsValue || !fieldsValue.question_type) {
                  return false;
                }
                if (fieldsValue.question_type == 1) {
                  return true;
                } else if (fieldsValue.question_type == 2) {
                  return false;
                } else {
                  return false;
                }
              },
              sm: 12,
            },
            spec_limit_suggest: {
              type: 'text',
              label: 'Spec Limit (合規界線) 設定建議',
              maxlength: 1000,
              displayCheck: function(fieldsValue) {
                if (!fieldsValue || !fieldsValue.question_type) {
                  return false;
                }
                if (fieldsValue.question_type == 1) {
                  return true;
                } else if (fieldsValue.question_type == 2) {
                  return false;
                } else {
                  return false;
                }
              },
              sm: 12,
            },
            title: {
              type: 'text',
              label: '題目主旨',
              autofocus: true,
              rules: 'required',
              maxlength: 100,
            },
            remark: {
              type: 'textarea',
              label: '合規標準',
              maxlength: 5000,
            },
          },
        },
        attaches: {
          type: 'files',
          label: '合規標準附件',
          uploadUrl: '/checklist_question_template_version/attach/',
          sm: 12,
        },
        acts: {
          label: '相關法規',
          type: 'act-picker',
          modelName: 'act',
          textKey: 'name',
          noReset: true,
          fields: act.fields,
          requiredField: 'areas',
          hasCloseChips: true,
          conditionKeys: [
            {
              fieldName: 'areas',
              conditionName: 'areas',
              type: 'array',
            },
          ],
          getText: (item) => {
            if (!item.last_version) {
              return null;
            } else {
              return `${item.last_version.name}`;
            }
          },
          sm: 6,
        },
        effects: {
          label: '風險燈號',
          type: 'hasMany',
          modelName: 'effect',
          textKey: 'name',
          sm: 12,
          conditionKeys: [
            {
              fieldName: 'areas',
              conditionName: 'area',
              type: 'array',
            },
          ],
        },
      },
    },
  },
  fieldsRead: [
    'last_version.isInStats',
    'last_version.question_type',
    'last_version.optionSetting',
    'last_version.optionInfo',
    'last_version.numericalComparisonSettingInfo',
    'last_version.numericalComparisonConditionSettingInfo',
    'last_version.control_limit_lower',
    'last_version.control_limit_upper',
    'last_version.spec_limit_lower',
    'last_version.spec_limit_upper',
    'last_version.unit',
    'last_version.locales',
    'last_version.acts',
    'last_version.attaches',
    'last_version.effects',
  ],
};
